module.exports = __webpack_public_path__ + "static/media/footer-3.83f0126b.svg";